import { createSelector } from 'reselect'
import { propOr } from 'ramda'

const getPortfolioState = state => state.portfolio

export const selectPortfolioList = createSelector(
  getPortfolioState,
  propOr([], 'list')
)

export const selectSelectedPortfolio = createSelector(
  getPortfolioState,
  propOr(null, 'selected')
)

export const selectPortfolioError = createSelector(
  getPortfolioState,
  propOr(null, 'selectedError')
)

export const selectPortfolioLoading = createSelector(
  getPortfolioState,
  propOr(false, 'isLoading')
)
